import React from 'react';

const RulesContent = () => {
  return (
    <div>
      <p>Regulile centrului sunt următoarele:</p>
      <ul>
        <li>Aplicarea pentru spațiu se face cu minim 3 zile înainte de activitate.</li>
        <li>Consumabilele(materialele) necesare pentru activitate nu pot fi achiziționate/împrumutate de la STUDEM.</li>
        <li>Spațiul trebuie reîntors exact în starea în care a fost primit (după orice activitate se face curățenie, mobilierul este aranjat ca la primirea spațiului).</li>
        <li>Toate bunurile din cadrul centrului nu trebuie sa fie deteriorate.</li>
        <li>Centrul nu duce răspundere de lucrurile personale ale beneficiarilor.</li>
        <li>Nu aruncați fotoliile sac în aer și nu săriți pe ele!</li>
        <li>Dacă înainte sau după activitatea dvs. este un alt eveniment atunci este nevoie de o pauză de minim 1 ora.</li>
        <li>În cadrul activităților dvs. nu trebuie să se promoveze violența și discriminarea.</li>
        <li>În cazul în care mobilierul sau alt bun al centrului va fi deteriorat după evenimentul dvs., acesta va fi reparat/cumpărat de către dvs.</li>
        <li>La începutul activităţii se semnează acordul pe proprie răspundere, în care este stipulat că dvs sunteți de acord cu toate regulile stipulate de către Centrul de Tineret- STUDEM. În cazul în care acordul nu este semnat de către organizator, spațiul nu este oferit.</li>
      </ul>
    </div>
  );
};

export default RulesContent;
